import styles from "./login.module.scss";
import Logo from "../../assets/images/logo.svg";
import Button from "../../components/button/Button";
import { loginRequest } from "../../authConfig";
import constants from "../../utilities/constants";
import msalInstance from "../../app/msal";

const Login = () => {
  const handleLogin = async () => {
    await msalInstance.loginRedirect(loginRequest);
  };

  return (
    <div className={styles.body}>
      <div className={styles.logo}>
        <img src={Logo} alt="daikin-logo"></img>
      </div>
      <div className={styles.card}>
        <div className={styles.heading}>
          Daikin Shared {"\n"} Data Portal
          <p className={styles.description}>
            To use this portal, please login with your Daikin City account
            information.
          </p>
        </div>
        <Button
          style={styles.button}
          onClick={async () => {
            await handleLogin();
          }}
        >
          Login / SignUp
        </Button>
        <div className={styles.tAndCDiv}>
          <i
            className={styles.tAndCLink}
            onClick={() => {
              window.open(constants.privacyPolicy, "_blank");
            }}
          >
            Privacy Policy
          </i>
          <i
            className={styles.tAndCLink}
            onClick={() => {
              window.open(constants.termsOfUse, "_blank");
            }}
          >
            Terms of Use
          </i>
        </div>
      </div>
    </div>
  );
};

export default Login;
